import { Component, DOCUMENT, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from "../environments/environment";

@Component({
    selector: 'abq-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
    title: string = 'AbaQus Field';
    private readonly document: Document = inject(DOCUMENT);

    ngOnInit(): void {
        this.setFavicon();
        this.setTitle();
    }

    private setFavicon(): void {
        let link: HTMLLinkElement | null = this.document.querySelector("link[rel*='icon']") as HTMLLinkElement | null;

        if (!link) {
            link = this.document.createElement('link');
            link.rel = 'icon';
            this.document.head.appendChild(link);
        }

        link.type = 'image/x-icon';
        link.href = environment.faviconFile;
    }

    private setTitle(): void {
        const tabName = `${this.title}${environment.environmentNameSuffix}`;
        document.title = tabName;
    }

}
